<section class="license-list">
  @if (licenses.length > 0) {
    <p-table
      #licenseTable
      [value]="licenses"
      dataKey="id"
      selectionMode="single"
      [(selection)]="selectedLicense"
      [globalFilterFields]="['name']"
      (onRowSelect)="handleRowClick()"
    >
      <ng-template #caption>
        <div class="filter-container">
          <p-floatlabel variant="on">
            <p-iconfield>
              <p-inputicon class="pi pi-search" />
              <input
                pInputText
                type="text"
                (input)="onGlobalFilter($event, licenseTable)"
                class="w-20rem"
              />
            </p-iconfield>
            <label for="over_label">Filter by name</label>
          </p-floatlabel>
        </div>
      </ng-template>

      <ng-template #header>
        <tr>
          <th>Name</th>
          <th>Host</th>
          <th>Auth Host</th>
          <th>Status</th>
          <th style="width: 1px">Actions</th>
        </tr>
      </ng-template>
      <ng-template #body let-license>
        <tr [pSelectableRow]="license">
          <td>{{ license.name }}</td>
          <td>{{ license.address }}</td>
          <td>{{ license.authAddress }}</td>
          <td>
            <p-tag
              [value]="licenseService.getStatusName(license.status)"
              [severity]="licenseService.getStatusStyles(license.status)"
            />
          </td>
          <td>
            <div class="license-list__actions">
              <p-button
                label="Edit"
                size="small"
                icon="pi pi-pencil"
                aria-label="Edit"
                severity="secondary"
                raised
                (click)="handleEditLicenseClick(license)"
              />
              <p-button
                label="Delete"
                size="small"
                icon="pi pi-trash"
                aria-label="Delete"
                severity="danger"
                raised
                (click)="handleDeleteLicenseClick($event, license.id)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-confirmdialog />

    <cognos-license-details-dialog
      [(isOpen)]="isLicenseDetailVisible"
      [companyName]="companyName"
      [license]="licenseDetails"
      [version]="this.licenseService.licenseVersion$()?.version"
      [settings]="licenseSettings"
      [remoteSourcesList]="this.licenseService.remoteSourcesList$()"
      (licenseUpdated)="onLicenseUpdated($event)"
    ></cognos-license-details-dialog>
  } @else {
    <p>There are no licenses yet.</p>
  }
</section>
